import React, { useEffect, useState } from "react";
import "../css/dpi-admin.css";
import Matrixgrid from "../components/Matrixgrid";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../config";
import Surveyquestion from "../components/Surveyquestion";
import { setRef } from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function Surveyadd() {
  const [controltype, setControlType] = useState([]);
  const [inputType, setInputType] = useState([]);
  const [ismultival, setIsMultiVal] = useState(false);
  const [option, setOption] = useState([{ 0: "" }]);
  const [isratingscale, setIsRatingScale] = useState(false);
  const [isslider, setIsSlider] = useState(false);
  const [blnupdatelist, setBlnUpdateList] = useState(true);
  const [savedquestions, setSavedQuestions] = useState([]);
  const [newquestion, setNewQuestion] = useState([]);
  const [newquestionprop, setNewQuestionProp] = useState([]);
  const [isReqChecked, setIsReqChecked] = useState(false);
  const [errors, setErrors] = useState({});
  const [editQuestion, setEditQuestion] = useState([]);
  const [editQuestionOptions, setEditQuestionOptions] = useState([]);

  const [isEditQuesMultiVal, setIsEditQuesMultiVal] = useState(false);
  const [isEditQuesRatingScale, setIsEditQuesRatingScale] = useState(false);
  const [isEditQuesSlider, setIsEditQuesSlider] = useState(false);
  const [editQuestionProp, setEditQuestionProp] = useState([]);
  const [isEditReqChecked, setIsEditReqChecked] = useState();
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  let navNaigate = useNavigate();

  //Fetch Control
  useEffect(() => {
    const getControl = async () => {
      const resCtl = await fetch(`${API_BASE_URL}GetAllControls.php/1`);
      const resctl = await resCtl.json();

      setControlType(await resctl.data);
    };
    getControl();
  }, []);

  //Fetch Data Type
  useEffect(() => {
    const getControl = async () => {
      const resCtl = await fetch(`${API_BASE_URL}GetMasterData.php/3`);
      const resctl = await resCtl.json();

      setInputType(await resctl.data);
    };
    getControl();
  }, []);

  //Fetch all questions
  useEffect(() => {
    const getQuestions = async () => {
      const resQues = await fetch(
        `${API_BASE_URL}GetAllQuestionsBySurveyId.php/${
          sessionStorage.getItem("new_survey")
            ? JSON.parse(sessionStorage.getItem("new_survey")).surv_id
            : 0
        }`
      );
      const resquesjson = await resQues.json();
      console.log(JSON.parse(sessionStorage.getItem("new_survey")).surv_id);
      setSavedQuestions(await resquesjson.data);
      setNewQuestion((prev) => []);
      setNewQuestionProp((prev) => []);
      setIsReqChecked(false);
      setOption((prev) => [{ 0: "" }]);
      setIsMultiVal((prev) => false);
      setIsRatingScale(false);
      setIsSlider(false);
      setIsLoading(false);
    };
    getQuestions();
  }, [blnupdatelist]);

  //Fetch Data Type
  useEffect(() => {
    const getAllOptionByQuesId = async () => {
      const resCtl = await fetch(
        `${API_BASE_URL}GetAllMultiQuestionOptions.php/${editQuestion.surv_ques_id}`
      );
      const resctl = await resCtl.json();
      if (resctl.data) {
        setEditQuestionOptions(await resctl.data);
      } else {
        setEditQuestionOptions([{ 0: "" }]);
      }

      //console.log(resctl.data);
    };
    getAllOptionByQuesId();
  }, [editQuestion.surv_ques_id]);

  const OnControlType_Change = (event) => {
    console.log(parseInt(event.target.value));
    if (
      parseInt(event.target.value) === 2 ||
      parseInt(event.target.value) === 3 ||
      parseInt(event.target.value) === 4 ||
      parseInt(event.target.value) === 6
    ) {
      setIsMultiVal(true);
      setIsRatingScale(false);
      setIsSlider(false);
      setNewQuestionProp({ is_multi_val: 1 });
    } else if (parseInt(event.target.value) === 7) {
      setIsRatingScale(true);
      setIsMultiVal(false);
      setIsSlider(false);
      setOption([{ 0: "" }]);
      setNewQuestionProp({ is_multi_val: 0 });
    } else if (parseInt(event.target.value) === 8) {
      setIsSlider(true);
      setIsMultiVal(false);
      setIsRatingScale(false);
      setOption([{ 0: "" }]);
      setNewQuestionProp({ is_multi_val: 0 });
    } else {
      setIsMultiVal(false);
      setIsRatingScale(false);
      setOption([{ 0: "" }]);
      setIsSlider(false);
      setNewQuestionProp({ is_multi_val: 0 });
    }
    setNewQuestion({
      ...newquestion,
      [event.target.id]: event.target.value,
    });
  };

  const OnEditQuesControlType_Change = (event) => {
    if (
      parseInt(event.target.value) === 2 ||
      parseInt(event.target.value) === 3 ||
      parseInt(event.target.value) === 4
    ) {
      setIsEditQuesMultiVal(true);
      setIsEditQuesRatingScale(false);
      setIsEditQuesSlider(false);
      setEditQuestionProp({ is_multi_val: 1 });
      setEditQuestionOptions([{ 0: "" }]);
    } else if (parseInt(event.target.value) === 7) {
      setIsEditQuesRatingScale(true);
      setIsEditQuesMultiVal(false);
      setIsEditQuesSlider(false);
      setEditQuestionOptions([{ 0: "" }]);
      setEditQuestionProp({ is_multi_val: 0 });
    } else if (parseInt(event.target.value) === 8) {
      setIsEditQuesSlider(true);
      setIsEditQuesMultiVal(false);
      setIsEditQuesRatingScale(false);
      setEditQuestionOptions([{ 0: "" }]);
      setEditQuestionProp({ is_multi_val: 0 });
    } else {
      setIsEditQuesMultiVal(false);
      setIsEditQuesRatingScale(false);
      setEditQuestionOptions([{ 0: "" }]);
      setIsEditQuesSlider(false);
      setEditQuestionProp({ is_multi_val: 0 });
    }

    //Clear all the previous items of question except surv_ques_id, surv_ques_code, surv_ques_label
    const { surv_ques_id, surv_ques_code, surv_ques_label, is_req } =
      editQuestion;
    setEditQuestion({
      surv_ques_id,
      surv_ques_code,
      surv_ques_label,
      is_req,
      [event.target.id]: event.target.value,
    });
    //console.log(editQuestion);
  };

  const handleOptInput = (event, index) => {
    const { id, value } = event.target;
    const newOption = [...option];
    newOption[index][id] = value;
    setOption(newOption);
  };

  const handleAddOpt = () => {
    setOption([...option, {}]);
  };

  const handleRemoveOpt = (index) => {
    if (option.length > 1) {
      const newOption = [...option];
      newOption.splice(index, 1);
      setOption(newOption);
    } else {
      setIsMultiVal(false);
    }
  };

  const handleEditQuesOptInput = (event, index) => {
    const { id, value } = event.target;
    const newEditQuesOption = [...editQuestionOptions];
    editQuestionOptions[index].ques_opt_txt = value;
    setEditQuestionOptions(newEditQuesOption);
  };

  const handleEditQuesAddOpt = () => {
    setEditQuestionOptions([...editQuestionOptions, {}]);
  };

  const handleEditQuesRemoveOpt = (index) => {
    if (editQuestionOptions.length > 1) {
      const newEditQuesOption = [...editQuestionOptions];
      newEditQuesOption.splice(index, 1);
      setEditQuestionOptions(newEditQuesOption);
    } else {
      setIsMultiVal(false);
    }
  };

  const handlequestionsave = () => {
    //console.log(survey[0].surv_id);
    const errMsg = isvalidate();
    if (errMsg === "") {
      savequestion();
    } else {
      alert(errMsg);
    }
  };

  const handleQuestionUpdate = () => {
    const errMsg = isValidateEditQues();
    if (errMsg === "") {
      UpdateQuestion();
    } else {
      alert(errMsg);
    }
  };

  const isvalidate = () => {
    if (!newquestion.surv_ques_label) {
      return "Question label is missing";
    }
    if (!newquestion.ctrl_id) {
      return "Question type is missing";
    }
    return "";
  };

  const isValidateEditQues = () => {
    if (!editQuestion.surv_ques_label) {
      return "Question label is missing";
    }
    if (!editQuestion.ctrl_id) {
      return "Question type is missing";
    }
    return "";
  };

  const savequestion = async () => {
    setIsSaving(true);
    try {
      const surveyArray = [
        {
          surv_id: sessionStorage.getItem("new_survey")
            ? JSON.parse(sessionStorage.getItem("new_survey")).surv_id
            : 0,
        },
        {
          user_name: sessionStorage.getItem("user_credential")
            ? JSON.parse(sessionStorage.getItem("user_credential")).user_name
            : "",
        },
      ];

      const mergedArray = {
        questions: [
          { ...newquestion, ...newquestionprop, options: { ...option } },
        ],
      };
      //console.log(newquestion.surv_ques_label);
      surveyArray.push(mergedArray);
      //console.log(surveyArray);

      const formfldData = new FormData();
      formfldData.append("new_question", JSON.stringify(surveyArray));

      const templsaver = await axios
        .post(`${API_BASE_URL}InsertSurveyQuestion.php`, formfldData, {
          hearders: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          //window.location.reload();
          setBlnUpdateList(blnupdatelist ? false : true);
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    } finally {
      setIsSaving(false);
    }
  };

  const UpdateQuestion = async () => {
    const editSurveyArray = [
      {
        surv_id: sessionStorage.getItem("new_survey")
          ? JSON.parse(sessionStorage.getItem("new_survey")).surv_id
          : 0,
      },
      {
        user_name: sessionStorage.getItem("user_credential")
          ? JSON.parse(sessionStorage.getItem("user_credential")).user_name
          : "",
      },
    ];

    const mergedArray = {
      questions: [
        {
          ...editQuestion,
          ...editQuestionProp,
          options: { ...editQuestionOptions },
        },
      ],
    };
    //console.log(newquestion.surv_ques_label);
    editSurveyArray.push(mergedArray);
    //console.log(surveyArray);

    const formfldData = new FormData();
    formfldData.append("edit_question", JSON.stringify(editSurveyArray));

    const templsaver = await axios
      .post(`${API_BASE_URL}UpdateSurveyQuestion.php`, formfldData, {
        hearders: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        //window.location.reload();
        clearEditQues();
        setBlnUpdateList(blnupdatelist ? false : true);
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  };

  const deletequestion = async (event) => {
    const formfldData = new FormData();
    formfldData.append("surv_ques_id", event.target.id);
    formfldData.append(
      "surv_id",
      sessionStorage.getItem("new_survey")
        ? JSON.parse(sessionStorage.getItem("new_survey")).surv_id
        : 0
    );

    const templsaver = await axios
      .post(`${API_BASE_URL}DeleteSurveyQuestion.php`, formfldData, {
        hearders: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        //window.location.reload();
        setBlnUpdateList(blnupdatelist ? false : true);
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  };

  const handlenavigate = (path) => {
    navNaigate(path);
  };

  const handleReqChecked = () => {
    let checkedStatus = isReqChecked === false ? true : false;
    setIsReqChecked(checkedStatus);
    setNewQuestion({ ...newquestion, is_req: checkedStatus });
  };

  const handleEditReqChecked = () => {
    let checkedStatus = isEditReqChecked === false ? true : false;
    setIsEditReqChecked(checkedStatus);
    setEditQuestion({ ...editQuestion, is_req: checkedStatus });
  };

  const handleEditQuestion = (edit_ques) => {
    console.log(edit_ques.is_req);
    setIsEditReqChecked(parseInt(edit_ques.is_req) === 1 ? true : false);
    setEditQuestion(edit_ques);
  };

  const handleEditCancel = () => {
    const confirmed = window.confirm("Are you sure you want to cancel?");
    if (confirmed) {
      setEditQuestion([]);
    }
  };

  const clearEditQues = () => {
    setEditQuestion([]);
    setIsEditQuesMultiVal(false);
    setIsEditQuesRatingScale(false);
    setIsEditQuesSlider(false);
    setEditQuestionProp([]);
    setIsEditReqChecked(false);
  };

  const moveQues = async (event) => {
    //console.log(event.target.name);
    const formfldData = new FormData();
    formfldData.append("surv_ques_id", event.target.id);
    formfldData.append("move_type", event.target.name);
    formfldData.append(
      "created_by",
      JSON.parse(sessionStorage.getItem("user_credential")).user_name
    );

    const templsaver = await axios
      .post(`${API_BASE_URL}UpdateSurveyQuestionOrder.php`, formfldData, {
        hearders: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        //window.location.reload();
        setBlnUpdateList(blnupdatelist ? false : true);
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  };

  if (isLoading) {
    return (
      <div className="loader">
        <div className="spinner"></div>
        <p>Loading Page, please wait...</p>
      </div>
    );
  }
  return (
    <>
      <div className="col-xl-6 mx-auto">
        <div className="row">
          <div className="col-md-4">
            <button
              className="btn btn-primary btn-circle"
              id="btn_share_link"
              style={{ cursor: "pointer" }}
              onClick={() => handlenavigate("/surveyadd")}
              title="Create desired user input fields for your customize survey form"
            >
              1
            </button>
            &nbsp;&nbsp;
            <a
              className="mt-2"
              style={{ cursor: "pointer" }}
              onClick={() => handlenavigate("/surveyadd")}
            >
              Design
            </a>
          </div>
          <div className="col-md-4">
            <button
              className="btn btn-primary disabled btn-circle"
              id="btn_share_link"
              style={{ cursor: "pointer" }}
              onClick={() => handlenavigate("/surveysetup")}
              title="Choose users for your survey form or share survey link to specific participants"
            >
              2
            </button>
            &nbsp;&nbsp;
            <a
              class="mt-2"
              style={{ cursor: "pointer" }}
              onClick={() => handlenavigate("/surveysetup")}
            >
              Setup
            </a>
          </div>
          <div className="col-md-4">
            <button
              className="btn btn-primary disabled btn-circle"
              id="btn_share_link"
              style={{ cursor: "pointer" }}
              onClick={() => handlenavigate("/surveyanalyze")}
              title="Analyze and access participants input and generate reports"
            >
              3
            </button>
            &nbsp;&nbsp;
            <a
              class="mt-2"
              style={{ cursor: "pointer" }}
              onClick={() => handlenavigate("/surveyanalyze")}
            >
              Analyze
            </a>
          </div>
        </div>
        <hr />
        <div className="card shadow mb-4 mt-4">
          <div class="card-body">
            <h3 className="mb-3">
              {sessionStorage.getItem("new_survey")
                ? JSON.parse(sessionStorage.getItem("new_survey")).surv_name
                : ""}
            </h3>
            <hr />
            <span className="text-danger">
              * Indicates required questions!
            </span>
            &nbsp;
          </div>
        </div>
        {/*        <h3>
          {sessionStorage.getItem("new_survey")
            ? JSON.parse(sessionStorage.getItem("new_survey")).surv_name
            : ""}
        </h3>
*/}
        <div>&nbsp;</div>
        {savedquestions?.map((ques, index) => (
          <>
            {editQuestion.surv_ques_id === ques.surv_ques_id && (
              <div className="card shadow mb-3">
                <div className="card-header">
                  <h6>
                    <i className="fas fa-edit"></i>&nbsp;Edit Question
                  </h6>
                </div>
                <div className="card-body">
                  <div className="row gx-3 mb-3">
                    <div className="col-6">
                      <label className="btn-outline-danger">*</label>
                      <label className="small mb-1" for="Q1">
                        Question Label
                      </label>
                      <input
                        className="form-control"
                        id="surv_ques_label"
                        type="text"
                        placeholder="Label"
                        value={
                          editQuestion.surv_ques_label
                            ? editQuestion.surv_ques_label
                            : ""
                        }
                        onChange={(e) =>
                          setEditQuestion({
                            ...editQuestion,
                            surv_ques_label: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="col-6">
                      <label className="btn-outline-danger">*</label>
                      <label className="small mb-1" for="Q1">
                        Question Type
                      </label>
                      <select
                        id="ctrl_id"
                        className="custom-select mr-sm-2"
                        onChange={(e) => OnEditQuesControlType_Change(e)}
                        value={editQuestion.ctrl_id ? editQuestion.ctrl_id : 0}
                      >
                        <option selected>Choose...</option>
                        {controltype?.map((ctitem, index) => (
                          <option key={ctitem.id} value={ctitem.id}>
                            {ctitem.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <hr className="sidebar-divider" />
                  {(parseInt(editQuestion.ctrl_id) === 1 ||
                    parseInt(editQuestion.ctrl_id) === 5) && (
                    <div className="row gx-3 mb-3">
                      <div className="col-6">
                        <label className="small mb-1" for="Q1">
                          Input Type
                        </label>
                        <select
                          id="type_id"
                          className="custom-select mr-sm-2"
                          value={
                            parseInt(editQuestion.type_id)
                              ? parseInt(editQuestion.type_id)
                              : 0
                          }
                          onChange={(e) =>
                            setEditQuestion({
                              ...editQuestion,
                              type_id: e.target.value,
                            })
                          }
                        >
                          <option value="0" selected>
                            Choose...
                          </option>
                          {inputType?.map((opt, index) => (
                            <option value={opt.key}>{opt.val}</option>
                          ))}
                        </select>
                      </div>
                      {parseInt(editQuestion.type_id) === 1 ? (
                        <div className="col-6">
                          <div className="row">
                            <div className="col-6">
                              <label className="small mb-1" for="Q1">
                                Min Range
                              </label>
                              <input
                                className="form-control"
                                id="min_range"
                                type="number"
                                placeholder="Min Range"
                                value={
                                  editQuestion.min_range
                                    ? editQuestion.min_range
                                    : ""
                                }
                                onChange={(e) =>
                                  setEditQuestion({
                                    ...editQuestion,
                                    min_range: e.target.value,
                                  })
                                }
                              />
                            </div>
                            <div className="col-6">
                              <label className="small mb-1" for="Q1">
                                Max Range
                              </label>
                              <input
                                className="form-control"
                                id="max_range"
                                type="number"
                                placeholder="Max Range"
                                value={
                                  editQuestion.max_range
                                    ? editQuestion.max_range
                                    : ""
                                }
                                onChange={(e) =>
                                  setEditQuestion({
                                    ...editQuestion,
                                    max_range: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="col-6">
                          <label className="small mb-1" for="Q1">
                            Max Length (default 1200 characters)
                          </label>
                          <input
                            className="form-control"
                            id="max_length"
                            type="number"
                            placeholder="Max Length"
                            value={
                              editQuestion.max_length
                                ? editQuestion.max_length
                                : ""
                            }
                            onChange={(e) =>
                              setEditQuestion({
                                ...editQuestion,
                                max_length: e.target.value,
                              })
                            }
                          />
                        </div>
                      )}
                    </div>
                  )}

                  {(parseInt(editQuestion.is_multi_val) === 1 ||
                    isEditQuesMultiVal == true) &&
                    editQuestionOptions?.map((editOpt, index) => {
                      return (
                        <div className="row gx-3">
                          <div className="col-10">
                            <label className="small mb-1" for="Q1">
                              Option
                            </label>
                            <input
                              className="form-control"
                              id={index}
                              type="text"
                              placeholder="Option"
                              onChange={(e) => handleEditQuesOptInput(e, index)}
                              value={editOpt.ques_opt_txt}
                            />
                          </div>
                          <div className="col-2" style={{ marginTop: 30 }}>
                            <button
                              type="button"
                              className="btn btn-primary btn-circle btn-sm"
                              onClick={(e) => handleEditQuesAddOpt(e)}
                              title="Add Option"
                            >
                              <i className="fas fa-plus" />
                            </button>
                            &nbsp;&nbsp;
                            <button
                              type="button"
                              className="btn btn-primary btn-circle btn-sm"
                              onClick={() => handleEditQuesRemoveOpt(index)}
                              title="Remove Option"
                            >
                              <i className="fas fa-minus" />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  {(parseInt(editQuestion.ctrl_id) === 7 ||
                    isEditQuesRatingScale === true) && (
                    <div className="row gx-3">
                      <div className="col-8">
                        <label className="small mb-1" for="Q1">
                          Scale
                        </label>
                        <select
                          id="scale_range"
                          className="custom-select mr-sm-2"
                          value={editQuestion.scale_range}
                          onChange={(e) =>
                            setEditQuestion({
                              ...editQuestion,
                              [e.target.id]: e.target.value,
                            })
                          }
                        >
                          <option value="0">Choose..</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                          <option value="6">6</option>
                          <option value="7">7</option>
                          <option value="8">8</option>
                          <option value="9">9</option>
                          <option value="10">10</option>
                        </select>
                      </div>
                      <div className="col-4">
                        <span
                          key=""
                          style={{
                            cursor: "pointer",
                            color: "gold",
                            fontSize: "50px",
                          }}
                        >
                          &#9733; {/* &#9733; Unicode character for a star */}
                        </span>
                      </div>
                    </div>
                  )}
                  {(parseInt(editQuestion.ctrl_id) === 8 ||
                    isEditQuesSlider === true) && (
                    <div>
                      <div className="row gx-3">
                        <div className="col-6">
                          <label className="small mb-1">Min Range</label>
                          <input
                            className="form-control"
                            id="min_range"
                            type="number"
                            placeholder="Min Range"
                            value={
                              editQuestion.min_range
                                ? editQuestion.min_range
                                : 0
                            }
                            onChange={(e) =>
                              setEditQuestion({
                                ...editQuestion,
                                [e.target.id]: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="col-6">
                          <label className="small mb-1">Max Range</label>
                          <input
                            className="form-control"
                            id="max_range"
                            type="number"
                            value={
                              editQuestion.max_range
                                ? editQuestion.max_range
                                : 0
                            }
                            placeholder="Max Range"
                            onChange={(e) =>
                              setEditQuestion({
                                ...editQuestion,
                                [e.target.id]: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {parseInt(editQuestion.ctrl_id) === 16 && (
                    <div className="row gx-3 mb-3">
                      <div className="col-12">
                        <label className="btn-outline-danger">*</label>
                        <label className="small mb-1" for="Q1">
                          Description
                        </label>
                        {/*<textarea
                          className="form-control"
                          id="surv_ques_desc"
                          placeholder="Description"
                          value={
                            editQuestion.surv_ques_desc
                              ? editQuestion.surv_ques_desc
                              : ""
                          }
                          onChange={(e) =>
                            setEditQuestion({
                              ...editQuestion,
                              surv_ques_desc: e.target.value,
                            })
                          }
                        />*/}
                        <ReactQuill
                          id="surv_ques_desc"
                          value={
                            editQuestion.surv_ques_desc
                              ? editQuestion.surv_ques_desc
                              : ""
                          }
                          onChange={(value) =>
                            setEditQuestion({
                              ...editQuestion,
                              surv_ques_desc: value,
                            })
                          }
                        />
                      </div>
                    </div>
                  )}
                  <hr className="sidebar-divider" />
                  <div
                    className="row gx-3 mb-3"
                    style={{ alignItems: "right" }}
                  >
                    <div className="col-md-3">&nbsp;</div>
                    <div className="col-md-3">&nbsp;</div>
                    <div className="col-md-3">
                      {parseInt(editQuestion.ctrl_id) !== 16 && (
                        <>
                          <label className="small mt-3 mx-3">Required</label>
                          <label className="switch">
                            <input
                              id="is_req"
                              type="checkbox"
                              name="chk_required"
                              onChange={() => handleEditReqChecked()}
                              checked={isEditReqChecked}
                            />
                            <span className="slider sliderrounded" />
                          </label>
                        </>
                      )}
                    </div>
                    <div className="col-md-3">
                      <button
                        id="btn_add_ques"
                        className="btn btn-primary align-center"
                        type="button"
                        onClick={() => handleQuestionUpdate()}
                      >
                        Save
                      </button>
                      &nbsp;&nbsp;
                      <button
                        id="btn_edit_ques_cancel"
                        className="btn btn-primary align-center"
                        type="button"
                        onClick={handleEditCancel}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {editQuestion.surv_ques_id !== ques.surv_ques_id && (
              <div className="card shadow mb-3">
                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                  <h6>
                    {parseInt(ques.is_req) === 1 && (
                      <i className="text-danger">*&nbsp;</i>
                    )}
                    {ques.surv_ques_desc === "" && (
                      <>
                        Q.
                        {index + 1}
                      </>
                    )}
                    &nbsp;{ques.surv_ques_label}
                  </h6>
                  {parseInt(
                    JSON.parse(sessionStorage.getItem("new_survey")).is_publish
                  ) !== 1 && (
                    <div class="dropdown no-arrow">
                      <a
                        class="dropdown-toggle"
                        href="#"
                        role="button"
                        id="dropdownMenuLink"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
                      </a>
                      <div
                        class="dropdown-menu dropdown-menu-right shadow animated--fade-in"
                        aria-labelledby="dropdownMenuLink"
                      >
                        <div class="dropdown-header">Actions:</div>
                        <a
                          id={ques.surv_ques_id}
                          class="dropdown-item"
                          onClick={() => handleEditQuestion(ques)}
                          style={{ cursor: "pointer" }}
                        >
                          <i className="fas fa-edit"></i>&nbsp;&nbsp;Edit
                        </a>
                        <a
                          id={ques.surv_ques_id}
                          class="dropdown-item"
                          onClick={(e) => deletequestion(e)}
                          style={{ cursor: "pointer" }}
                        >
                          <i className="fas fa-trash"></i>&nbsp;&nbsp;Delete
                        </a>
                        {index > 0 && (
                          <a
                            id={ques.surv_ques_id}
                            class="dropdown-item"
                            style={{ cursor: "pointer" }}
                            name="move_up"
                            onClick={(e) => moveQues(e)}
                          >
                            <i className="fas fa-arrow-up"></i>&nbsp;&nbsp;Move
                            Up
                          </a>
                        )}
                        {index !== savedquestions?.length - 1 && (
                          <a
                            id={ques.surv_ques_id}
                            class="dropdown-item"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => moveQues(e)}
                            name="move_down"
                          >
                            <i className="fas fa-arrow-down"></i>
                            &nbsp;&nbsp;Move Down
                          </a>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div className="card-body">
                  <div className="row gx-3 mb-3">
                    <div className="col-md-12">
                      <Surveyquestion
                        Id={ques.surv_ques_id}
                        IsMultiVal={ques.is_multi_val}
                        ControlType={ques.ctrl_name}
                        InputType={ques.type_name}
                        MaxLength={parseInt(ques.max_length)}
                        MinRange={parseInt(ques.min_range)}
                        MaxRange={parseInt(ques.max_range)}
                        Description={ques.surv_ques_desc}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        ))}
        <div>&nbsp;</div>
        {parseInt(
          JSON.parse(sessionStorage.getItem("new_survey"))?.is_publish
        ) !== 1 && (
          <div className="card shadow">
            <div className="card-header">
              <h6>New Question</h6>
            </div>
            <div className="card-body">
              <div className="row gx-3 mb-3">
                <div className="col-6">
                  <label className="btn-outline-danger">*</label>
                  <label className="small mb-1" for="Q1">
                    Question Label
                  </label>
                  <input
                    className="form-control"
                    id="surv_ques_label"
                    type="text"
                    placeholder="Label"
                    value={
                      newquestion.surv_ques_label
                        ? newquestion.surv_ques_label
                        : ""
                    }
                    onChange={(e) =>
                      setNewQuestion({
                        ...newquestion,
                        surv_ques_label: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-6">
                  <label className="btn-outline-danger">*</label>
                  <label className="small mb-1" for="Q1">
                    Question Type
                  </label>
                  <select
                    id="ctrl_id"
                    className="custom-select mr-sm-2"
                    onChange={(e) => OnControlType_Change(e)}
                    value={newquestion.ctrl_id ? newquestion.ctrl_id : 0}
                  >
                    <option selected>Choose...</option>
                    {controltype?.map((ctitem, index) => (
                      <option key={ctitem.id} value={ctitem.id}>
                        {ctitem.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <hr className="sidebar-divider" />
              {(parseInt(newquestion.ctrl_id) === 1 ||
                parseInt(newquestion.ctrl_id) === 5) && (
                <div className="row gx-3 mb-3">
                  <div className="col-6">
                    <label className="small mb-1" for="Q1">
                      Input Type
                    </label>
                    <select
                      id="type_id"
                      className="custom-select mr-sm-2"
                      value={newquestion.type_id ? newquestion.type_id : 0}
                      onChange={(e) =>
                        setNewQuestion({
                          ...newquestion,
                          type_id: e.target.value,
                        })
                      }
                    >
                      <option value="0" selected>
                        Choose...
                      </option>
                      {inputType?.map((opt, index) => (
                        <option value={opt.key}>{opt.val}</option>
                      ))}
                    </select>
                  </div>
                  {parseInt(newquestion.type_id) === 1 ? (
                    <div className="col-6">
                      <div className="row">
                        <div className="col-6">
                          <label className="small mb-1" for="Q1">
                            Min Range
                          </label>
                          <input
                            className="form-control"
                            id="min_range"
                            type="number"
                            placeholder="Min Range"
                            value={
                              newquestion.min_range ? newquestion.min_range : ""
                            }
                            onChange={(e) =>
                              setNewQuestion({
                                ...newquestion,
                                min_range: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="col-6">
                          <label className="small mb-1" for="Q1">
                            Max Range
                          </label>
                          <input
                            className="form-control"
                            id="max_range"
                            type="number"
                            placeholder="Max Range"
                            value={
                              newquestion.max_range ? newquestion.max_range : ""
                            }
                            onChange={(e) =>
                              setNewQuestion({
                                ...newquestion,
                                max_range: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="col-6">
                      <label className="small mb-1" for="Q1">
                        Max Length (default 1200 characters)
                      </label>
                      <input
                        className="form-control"
                        id="max_length"
                        type="number"
                        placeholder="Max Length"
                        value={
                          newquestion.max_length ? newquestion.max_length : ""
                        }
                        onChange={(e) =>
                          setNewQuestion({
                            ...newquestion,
                            max_length: e.target.value,
                          })
                        }
                      />
                    </div>
                  )}
                </div>
              )}

              {ismultival === true &&
                option?.map((opt, index) => {
                  return (
                    <div className="row gx-3">
                      <div className="col-10">
                        <label className="small mb-1" for="Q1">
                          Option
                        </label>
                        <input
                          className="form-control"
                          id={index}
                          type="text"
                          placeholder="Option"
                          onChange={(e) => handleOptInput(e, index)}
                        />
                      </div>
                      <div className="col-2" style={{ marginTop: 30 }}>
                        <button
                          type="button"
                          className="btn btn-primary btn-circle btn-sm"
                          onClick={(e) => handleAddOpt(e)}
                        >
                          <i className="fas fa-plus" />
                        </button>
                        &nbsp;&nbsp;
                        <button
                          type="button"
                          className="btn btn-primary btn-circle btn-sm"
                          onClick={() => handleRemoveOpt(index)}
                        >
                          <i className="fas fa-minus" />
                        </button>
                      </div>
                    </div>
                  );
                })}
              {isratingscale === true && (
                <div className="row gx-3">
                  <div className="col-8">
                    <label className="small mb-1" for="Q1">
                      Scale
                    </label>
                    <select
                      id="scale_range"
                      className="custom-select mr-sm-2"
                      onChange={(e) =>
                        setNewQuestionProp({
                          ...newquestionprop,
                          [e.target.id]: e.target.value,
                        })
                      }
                    >
                      <option value="0">Choose..</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                    </select>
                  </div>
                  <div className="col-4">
                    <span
                      key=""
                      style={{
                        cursor: "pointer",
                        color: "gold",
                        fontSize: "50px",
                      }}
                    >
                      &#9733; {/* &#9733; Unicode character for a star */}
                    </span>
                  </div>
                </div>
              )}
              {isslider === true && (
                <div>
                  <div className="row gx-3">
                    <div className="col-6">
                      <label className="small mb-1">Min Range</label>
                      <input
                        className="form-control"
                        id="min_range"
                        type="number"
                        placeholder="Min Range"
                        onChange={(e) =>
                          setNewQuestionProp({
                            ...newquestionprop,
                            [e.target.id]: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="col-6">
                      <label className="small mb-1">Max Range</label>
                      <input
                        className="form-control"
                        id="max_range"
                        type="number"
                        placeholder="Max Range"
                        onChange={(e) =>
                          setNewQuestionProp({
                            ...newquestionprop,
                            [e.target.id]: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
              )}
              {parseInt(newquestion.ctrl_id) === 16 && (
                <div className="row gx-3 mb-3">
                  <div className="col-12">
                    <label className="btn-outline-danger">*</label>
                    <label className="small mb-1" for="Q1">
                      Description
                    </label>
                    {/*<textarea
                      className="form-control"
                      id="surv_ques_desc"
                      placeholder="Description"
                      value={
                        newquestion.surv_ques_desc
                          ? newquestion.surv_ques_desc
                          : ""
                      }
                      onChange={(e) =>
                        setNewQuestion({
                          ...newquestion,
                          surv_ques_desc: e.target.value,
                        })
                      }
                    />*/}
                    <ReactQuill
                      value={
                        newquestion.surv_ques_desc
                          ? newquestion.surv_ques_desc
                          : ""
                      }
                      onChange={(value) =>
                        setNewQuestion({
                          ...newquestion,
                          surv_ques_desc: value,
                        })
                      }
                      //onChange={handleDescriptionChange}
                      theme="snow"
                      placeholder="Enter section description here..."
                    />
                  </div>
                </div>
              )}
              <hr className="sidebar-divider" />
              <div className="row gx-3 mb-3" style={{ alignItems: "right" }}>
                <div className="col-md-3">&nbsp;</div>
                <div className="col-md-3">&nbsp;</div>

                <div className="col-md-3">
                  {parseInt(newquestion.ctrl_id) !== 16 && (
                    <>
                      <label className="small mt-3 mx-3">Required</label>
                      <label className="switch">
                        <input
                          id="is_req"
                          type="checkbox"
                          name="chk_required"
                          onChange={() => handleReqChecked()}
                          checked={isReqChecked}
                        />
                        <span className="slider sliderrounded" />
                      </label>
                    </>
                  )}
                </div>

                <div className="col-md-3">
                  <button
                    id="btn_add_ques"
                    className="btn btn-primary align-center"
                    type="button"
                    onClick={() => handlequestionsave()}
                    disabled={isSaving}
                  >
                    Save&nbsp;
                    {isSaving ? <span className="spinner"></span> : ""}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="row gx-3 mt-3">&nbsp;</div>
        <div className="row gx-3 mt-3 mb-5" style={{ marginLeft: "35%" }}>
          <button
            id="btn_submit"
            className="btn btn-primary align-center"
            type="button"
            onClick={() => handlenavigate("/surveysetup")}
          >
            &nbsp;&nbsp;Next&nbsp;&nbsp;
          </button>
        </div>
      </div>
    </>
  );
}
